import React from 'react'

import { Checkbox, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

function FilterChip({
  id,
  label,
  isChecked = false,
  disabled = false,
  isHiddenAtMd = false,
  onChange,
}) {
  // Triangle's <Checkbox> already toggles when its own area is clicked.
  // This handler only fires for clicks on the chip area around it (the 36px row is taller
  // than the Checkbox) — the e.target check filters out events bubbling from the Checkbox.
  const handleContainerClick = (event) => {
    if (event.target !== event.currentTarget || disabled) return
    onChange(!isChecked)
  }

  return (
    <div
      className={classnames(
        'filter-chip',
        disabled && 'filter-chip--disabled',
        isHiddenAtMd && 'filter-chip--hidden-at-md',
      )}
      onClick={handleContainerClick}
      role="presentation"
    >
      <Checkbox
        id={id}
        name={id}
        size="tiny"
        label={label}
        isChecked={isChecked}
        isControlled
        isDisabled={disabled}
        onChange={onChange}
        labelClassName="cgt-button-text-base"
        wrapperClassName="filter-chip__wrapper"
      />
    </div>
  )
}

FilterChip.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  isChecked: bool,
  disabled: bool,
  isHiddenAtMd: bool,
  onChange: func.isRequired,
}

export default FilterChip
